import styled from 'styled-components'

export const AccountStyled = styled.div`
    margin: 10px 0;
`

export const TitleBox = styled.div`
    text-align: center;
    border-bottom: 1px solid ${({ theme }) => theme.background};
    margin-bottom: 15px;
    padding-bottom: 15px;
`

export const Title = styled.div`
    font-size: 20px;
    letter-spacing: 0.06em;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.greyishBrown};
    margin-top: 20px;
    margin-bottom: 40px;
`

export const Element = styled.div`
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid ${({ theme }) => theme.background};
`

export const ElementTitle = styled.div`
    font-size: 15px;
    letter-spacing: 0.04em;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.greyishBrown};
    margin-bottom: 10px;
`